import { Navigate, useLocation } from 'react-router-dom';

/** /v2/cart → /cart, preserving query string and hash. */
export default function StripV2Redirect() {
  const { pathname, search, hash } = useLocation();
  const stripped = pathname.replace(/^\/v2/, '') || '/';
  return <Navigate to={`${stripped}${search}${hash}`} replace />;
}
